import type { RouteRecordRaw } from 'vue-router'

// Все маршруты IA из DESIGN_BRIEF §3. Незаполненные разделы рендерятся
// общим PlaceholderPage — структура каркаса видна целиком.

const placeholder = () => import('@/pages/PlaceholderPage.vue')

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'dashboard',
    component: () => import('@/pages/dashboard/DashboardPage.vue'),
    meta: { nav: 'dashboard' },
  },
  {
    path: 'activity',
    name: 'activity',
    component: () => import('@/pages/activity/ActivityListPage.vue'),
    meta: { nav: 'activity' },
  },

  // Backups
  {
    path: 'jobs',
    name: 'jobs',
    component: () => import('@/pages/jobs/JobsListPage.vue'),
    meta: { nav: 'jobs' },
  },
  {
    path: 'runs',
    name: 'runs',
    component: () => import('@/pages/runs/RunsListPage.vue'),
    meta: { nav: 'runs' },
  },
  {
    path: 'snapshots',
    name: 'snapshots',
    component: () => import('@/pages/snapshots/SnapshotsListPage.vue'),
    meta: { nav: 'snapshots' },
  },
  {
    path: 'restore',
    name: 'restore',
    component: () => import('@/pages/restore/RestorePage.vue'),
    meta: { nav: 'restore' },
  },
  {
    path: 'retention',
    name: 'retention',
    component: () => import('@/pages/retention/RetentionListPage.vue'),
    meta: { nav: 'retention' },
  },
  {
    path: 'job-presets',
    name: 'job-presets',
    component: () => import('@/pages/job-presets/JobPresetListPage.vue'),
    meta: { nav: 'job-presets' },
  },
  {
    path: 'integrity',
    name: 'integrity',
    component: () => import('@/pages/integrity/IntegrityPage.vue'),
    meta: { nav: 'integrity' },
  },

  // Infrastructure
  {
    path: 'devices',
    name: 'devices',
    component: () => import('@/pages/devices/DevicesListPage.vue'),
    meta: { nav: 'devices' },
  },
  {
    path: 'device-groups',
    name: 'device_groups',
    component: () => import('@/pages/device-groups/DeviceGroupsListPage.vue'),
    meta: { nav: 'device_groups' },
  },
  {
    path: 'storages',
    name: 'storages',
    component: () => import('@/pages/storages/StoragesListPage.vue'),
    meta: { nav: 'storages' },
  },
  {
    path: 'secrets',
    name: 'secrets',
    component: () => import('@/pages/secrets/SecretsListPage.vue'),
    meta: { nav: 'secrets' },
  },
  {
    path: 'enrollment',
    name: 'enrollment',
    component: () => import('@/pages/enrollment/EnrollmentListPage.vue'),
    meta: { nav: 'enrollment' },
  },

  // Monitoring
  {
    path: 'reports',
    name: 'reports',
    component: () => import('@/pages/reports/ReportsPage.vue'),
    meta: { nav: 'reports' },
  },
  { path: 'notifications', name: 'notifications', component: placeholder, meta: { nav: 'notifications' } },

  // Access
  {
    path: 'users',
    name: 'users',
    component: () => import('@/pages/users/UsersListPage.vue'),
    meta: { nav: 'users' },
  },
  {
    path: 'roles',
    name: 'roles',
    component: () => import('@/pages/roles/RolesListPage.vue'),
    meta: { nav: 'roles' },
  },
  {
    path: 'api-keys',
    name: 'api_keys',
    component: () => import('@/pages/api-keys/ApiKeysListPage.vue'),
    meta: { nav: 'api_keys' },
  },
  {
    path: 'security',
    name: 'security',
    component: () => import('@/pages/security/SecurityPage.vue'),
    meta: { nav: 'security' },
  },

  // Organization
  {
    path: 'org-settings',
    name: 'org_settings',
    component: () => import('@/pages/org-settings/OrgSettingsPage.vue'),
    meta: { nav: 'org_settings' },
  },
  {
    path: 'tags',
    name: 'tags',
    component: () => import('@/pages/tags/TagsListPage.vue'),
    meta: { nav: 'tags' },
  },
  {
    path: 'audit',
    name: 'audit',
    component: () => import('@/pages/audit/AuditPage.vue'),
    meta: { nav: 'audit' },
  },

  // Administration (superadmin)
  { path: 'admin/partners', name: 'partners', component: placeholder, meta: { nav: 'partners' } },
  { path: 'admin/organizations', name: 'organizations', component: placeholder, meta: { nav: 'organizations' } },
  { path: 'admin/plans', name: 'plans_quotas', component: placeholder, meta: { nav: 'plans_quotas' } },
  { path: 'admin/system', name: 'system_settings', component: placeholder, meta: { nav: 'system_settings' } },
  { path: 'admin/agent-updates', name: 'agent_updates', component: placeholder, meta: { nav: 'agent_updates' } },
  { path: 'admin/service-health', name: 'service_health', component: placeholder, meta: { nav: 'service_health' } },

  { path: 'profile', name: 'profile', component: () => import('@/pages/profile/ProfilePage.vue') },
]

export const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    component: () => import('@/pages/auth/AuthLayout.vue'),
    children: [
      { path: 'login', name: 'login', component: () => import('@/pages/auth/LoginPage.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('@/shell/AppShell.vue'),
    meta: { auth: true },
    children: protectedRoutes,
  },
  { path: '/:catchAll(.*)', redirect: { name: 'dashboard' } },
]
